// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Z9wc","resendInfoText":"OnGoingPaymentBox_resendInfoText__qHvys"};